import React, { useState, useEffect } from "react";
import { setSectionHeader } from "src/slices/global";
import { useDispatch, useSelector } from "react-redux";
import LegislataButton from "../../components/LegislataButton";
import { get, post, deleteAPI } from "src/utils/axios";
import {
  currentOfficeSelector,
  currentOfficeIdSelector,
  officesSelector,
  setOffice,
} from "src/slices/office";
import PostTag from "./components/posttag";
import { useHistory } from "react-router-dom";
import parse from "html-react-parser";
import PostUpdatedTime from "src/components/UpdatedTime";
import CommentDeleteModal from "./components/commentdeletemodal";
import PublicPopup from "src/components/PublicPopup";
import toast from "react-hot-toast";
import useAuth from "src/hooks/useAuth";

const Particular = props => {
  const post_id = props.match.params.id;

  const offices = useSelector(officesSelector);

  const { user } = useAuth();
  const dispatch = useDispatch();

  const currentOffice = useSelector(currentOfficeSelector);
  const currentOfficeId = useSelector(currentOfficeIdSelector);

  const role = currentOffice.attributes.role;
  const [description, setDescription] = useState("");
  const [name, setName] = useState("");
  const [time, setTime] = useState("");
  const [author, setAuthor] = useState("");
  const [bills, setBills] = useState([]);
  const [topics, setTopics] = useState([]);
  const [issues, setIssues] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [comment, setComment] = useState("");
  const [comments, setComments] = useState([]);
  const [isEmptyComment, setIsEmptyComment] = useState(false);
  const [postError, setPostError] = useState(false);
  const [hoverCommentId, setHoverCommentId] = useState("");
  const [deleteCommentId, setDeleteCommentId] = useState("");
  const [isShowModal, setIsShowModal] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);

  const history = useHistory();

  useEffect(async () => {
    // get the parameter oid from the query string
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const oid = urlParams.get("oid");
    // if a user is not authenticated, then redirect him to the public post page
    if (!user) {
      history.push(`/public_offices/${oid}/posts/${post_id}`);
    }

    if (currentOfficeId !== null) {
      // switch to a different office (from the user's allowed office list) if
      // url contains query param oid (office id). This can happen if there was a link
      // to a post from an email notification
      if (!oid || oid === currentOfficeId) {
        setPostData();
        return;
      }

      // switch to a different office if user is a member
      if (offices.length > 0) {
        const foundOffice = offices.find(
          office => office.id === oid.toString()
        );

        // if value of oid is one of the user's office_ids
        if (foundOffice) {
          dispatch(setOffice(foundOffice));
          setPostData();
          return;
        } else {
          history.push("/posts");
        }
      }

      setPostError(true);
    }
  }, [currentOfficeId, post_id]);

  const setPostData = async () => {
    let url = `api/v1/posts/${post_id}?office_id=${currentOfficeId}`;
    let result = await get(url);
    const postData = result.data.data.attributes;

    dispatch(setSectionHeader({ pageTitle: postData.title }));
    setName(postData.user.first_name + " " + postData.user.last_name);
    setTime(postData.updated_at);
    setDescription(formatDescriptionHandler(postData.description));
    setBills(postData.bills);
    setTopics(postData.topics);
    setIssues(postData.issues);
    setContacts(postData.contacts);
    setAuthor(postData.user);

    let result_comments = await get(
      `api/v1/posts/${post_id}/comments?office_id=${currentOfficeId}`
    );
    let comments = result_comments.data.data;
    setComments(comments.reverse());
  };

  const formatDescriptionHandler = description => {
    if (!description) return "";
    let formattedDescription = description;
    const ul_find_regex = /<\/*ul>/gm;
    const ul_found = description.match(ul_find_regex);
    if (ul_found !== null && ul_found.length > 0) {
      const regex = /<ul>/gm;
      formattedDescription = formattedDescription.replaceAll(
        regex,
        "<ul className='list-disc ml-6'>"
      );
    }

    const ol_find_regex = /<\/*ol>/gm;
    const ol_found = description.match(ol_find_regex);
    if (ol_found !== null && ol_found.length > 0) {
      const regex = /<ol>/gm;
      formattedDescription = formattedDescription.replaceAll(
        regex,
        "<ol className='list-decimal ml-6'>"
      );
    }

    // modify indent of <li> tag
    const indent_li_regex = /ql-indent-[1-9]/gm;
    const li_indents = description.match(indent_li_regex);
    if (li_indents !== null && li_indents.length > 0) {
      for (let indent_element of li_indents) {
        const suffix_number = indent_element.split("-")[2];
        const indent_size = parseInt(suffix_number) * 8;
        const margin_size = `ml-${indent_size}`;
        formattedDescription = formattedDescription.replace(
          indent_element,
          margin_size
        );
      }
    }

    // modify indent of normal text
    const indent_text_regex = />\t(.*?)</gm;
    const text_indents = description.match(indent_text_regex);
    if (text_indents !== null && text_indents.length > 0) {
      for (let indent of text_indents) {
        var num_tabs = indent.length - indent.replace(/\t/g, "").length;
        const indent_size = num_tabs * 4;
        const indent_text = ` className="ml-${indent_size}"${indent}`;

        formattedDescription = formattedDescription.replace(
          indent,
          indent_text
        );
      }
    }

    return formattedDescription;
  };

  const createPostHandler = async () => {
    if (comment === "") {
      setIsEmptyComment(true);
      return;
    }
    var data = {
      body: comment,
    };
    let new_comment = await post(
      `api/v1/posts/${post_id}/comments?office_id=${currentOfficeId}`,
      data
    );
    setComments([new_comment.data.data, ...comments]);
    setComment("");
  };

  const commentHandler = comment => {
    setComment(comment);
    setIsEmptyComment(false);
  };

  const mouseEnterCommentHandler = id => {
    setHoverCommentId(id);
  };

  const mouseLeaveCommentHandler = () => {
    setHoverCommentId("");
  };

  const deleteCommentHandler = () => {
    setDeleteCommentId(hoverCommentId);
    setIsShowModal(true);
  };

  const closeModalHandler = async result => {
    if (result) {
      try {
        await deleteAPI(
          `api/v1/posts/${post_id}/comments/${deleteCommentId}?office_id=${currentOfficeId}`
        );
        const newComments = comments.filter(
          comment => comment.id !== deleteCommentId
        );
        setComments(newComments);
      } catch (e) {
        toast("Something broke, please retry your request…");
      }
    }
    setIsShowModal(false);
  };

  const handleEdit = () => {
    history.push(`/posts/${post_id}/edit`);
  };

  if (postError) {
    return <h1 className="mt-8">Post not found</h1>;
  }

  return (
    <div>
      {role == "admin" || user.id == author.id ? (
        <div className="flex justify-end">
          <LegislataButton
            type="outline"
            customStyle="text-blue-700 border-blue-500 hover:bg-blue-500"
            onClick={handleEdit}
          >
            Edit
          </LegislataButton>
        </div>
      ) : (
        <div></div>
      )}
      <div className="grid grid-cols-3 gap-4">
        <div className="col-span-2">
          <div className="appearance-none">
            <div className="flex items-baseline mb-2 space-x-1">
              <span className="">{name}</span>
              <PostUpdatedTime
                timestamp={time}
                className="text-sm text-gray-700"
              />
            </div>
            <div>{parse(description)}</div>
          </div>
          <div className="appearance-none mt-4" style={{ minHeight: "300px" }}>
            <div className="mb-1  max-h-full">
              <span className="font-bold text-2xl">Comments</span>
              <span className="text-red-600"> *</span>
              <div className="grid grid-cols-12 gap-4 flex items-center mr-3">
                <div className="col-span-11">
                  <textarea
                    className={`${
                      isEmptyComment ? "border-red-500" : "border-gray-400"
                    } shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline`}
                    id="description"
                    name="description"
                    type="text"
                    placeholder="Add a comment."
                    value={comment}
                    onChange={e => commentHandler(e.target.value)}
                  ></textarea>
                </div>
                <div className="col-span-1">
                  <LegislataButton type="primary" onClick={createPostHandler}>
                    Post
                  </LegislataButton>
                </div>
              </div>
              <div className="overflow-y-auto space-y-3">
                {comments.map(comment => {
                  var datetime = new Date(
                    Date.parse(comment.attributes.created_at)
                  );
                  var datetimestr = datetime.toLocaleString();
                  datetimestr = datetimestr.substring(
                    0,
                    datetimestr.length - 3
                  );
                  return (
                    <div
                      key={comment.id}
                      onMouseEnter={() => mouseEnterCommentHandler(comment.id)}
                      onMouseLeave={mouseLeaveCommentHandler}
                    >
                      <div className="flex justify-between">
                        <span className="text-xs text-gray-500">
                          Posted by {comment.attributes.user.name} on{" "}
                          {datetimestr}
                        </span>
                        <button
                          className={`bg-grey-light hover:bg-grey text-grey-darkest py-0.5 px-4 rounded inline-flex items-center mr-3 ${
                            hoverCommentId === comment.id
                              ? "visible"
                              : "invisible"
                          }`}
                          onClick={deleteCommentHandler}
                        >
                          <span className="text-sm text-red-600 mr-1 underline">
                            Delete
                          </span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-4 w-4"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                            />
                          </svg>
                        </button>
                      </div>
                      <p className="text-sm">{comment.attributes.body}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div className="min-h-screen appearance-none p-3">
          <div>
            <span className="font-bold text-2xl">Tags</span>
          </div>
          <PostTag tag_title="Bills" tags={bills} />
          <PostTag tag_title="Topics" tags={topics} />
          <PostTag tag_title="Subtopics" tags={issues} />
          <PostTag tag_title="Contacts" tags={contacts} />
        </div>
      </div>
      <CommentDeleteModal isShow={isShowModal} onClose={closeModalHandler} />
      <PublicPopup isOpen={isOpenModal} onClose={() => setIsOpenModal(false)} />
    </div>
  );
};

export default Particular;
